import * as React from 'react';
import getStore from '../store/store';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { observer } from 'mobx-react-lite';
import { setTraceDatapoints } from 'owa-analytics-actions';

function onChange() {
    setTraceDatapoints(!getStore().traceDatapoints);
}

const TraceToggle = observer(function TraceToggle(props: {}) {
    return (
        <div>
            <Toggle
                checked={getStore().traceDatapoints}
                offText="Turn on datapoint tracing"
                onText="turn off datapoints tracing"
                onChanged={onChange}
            />
        </div>
    );
});
export default TraceToggle;
